import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  accordion: {
    display: 'grid',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '16px',
  },
  rate: {
    fontSize: '2.0rem',
    opacity: '1 !important',
  },
  label: {
    fontSize: spacing(12),
    fontWeight: 'bold',
    color: Theme.Colors.Grayscale.Eighty,
    fontFamily: Theme.Typography.FontFamily.Roboto,
  },

  infoText: {
    marginTop: spacing(30),
    display: 'flex',
    alignItems: 'flex-start',
    gap: spacing(6),
    gridColumn: '1 / -1',

    '& svg': {
      marginTop: spacing(6),
      flexShrink: 0,
    },
  },
}))
